var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "border-radius": "5px", overflow: "hidden" } },
    [
      _c(
        "virtual-scroll",
        {
          ref: "virtualScrollCte",
          attrs: {
            data: _vm.cteData,
            "item-size": 30,
            "key-prop": "keyPropId",
          },
          on: {
            change: function (virtualList) {
              return (_vm.list = virtualList)
            },
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.list,
                height: "500",
                "row-key": "keyPropId",
                "header-cell-style": { background: "#16a34a", color: "#fff" },
              },
            },
            _vm._l(_vm.xlsxHeader, function (item, index) {
              return _c("el-table-column", {
                key: index,
                attrs: {
                  label: item.label,
                  align: item.align,
                  prop: item.prop,
                  "min-width": item.minWidth,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          item.prop === "remetente"
                            ? _c("div", [
                                _vm._v(
                                  " " + _vm._s(scope.row.remetente.name) + " "
                                ),
                              ])
                            : item.prop === "frete"
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatNumber(scope.row.frete)) +
                                    " "
                                ),
                              ])
                            : item.prop === "productAmount"
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatNumber(scope.row.productAmount)
                                    ) +
                                    " "
                                ),
                              ])
                            : item.icmsAmount
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatNumber(scope.row.icmsAmount)
                                    ) +
                                    " "
                                ),
                              ])
                            : item.prop === "destinatario"
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.destinatario.name) +
                                    " "
                                ),
                              ])
                            : item.prop === "toma"
                            ? _c("div", [
                                _vm._v(" " + _vm._s(scope.row.toma.name) + " "),
                              ])
                            : item.prop === "tomadorCnpj"
                            ? _c("div", [
                                _vm._v(" " + _vm._s(scope.row.toma.cnpj) + " "),
                              ])
                            : item.prop === "destinatarioCnpj"
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.destinatario.cnpj) +
                                    " "
                                ),
                              ])
                            : item.prop === "remetenteCnpj"
                            ? _c("div", [
                                _vm._v(
                                  " " + _vm._s(scope.row.remetente.cnpj) + " "
                                ),
                              ])
                            : _c("div", [_vm._v(_vm._s(scope.row[item.prop]))]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }